module.exports = __webpack_public_path__ + "static/img/unimed.e47758a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patrocinio/unimed.png
// module id = yMvy
// module chunks = 1